import { FunctionComponent } from 'react';
import { twMerge } from 'tailwind-merge';
import { dividerStyles } from './Divider.styles';
import { DividerProps } from './types';

export const Divider: FunctionComponent<DividerProps> = ({
  intent = 'quaternary',
  variant = 'normal',
  size = 'sm',
  dividerWrapperClassName,
  dividerClassName,
  ...props
}) => {
  return (
    <div className={twMerge('flex items-center justify-center w-full', dividerWrapperClassName)} {...props.wrapperAttributes}>
      <hr className={twMerge('w-full', dividerStyles({ intent, variant, size }), dividerClassName)} {...props.dividerAttributes} />
    </div>
  );
};
